import React from 'react';

import GuidePage from '../../../js/pages/GuidePage';
import GuideLayout from '../../../js/pages/GuidePage/GuideLayout';
import PageContainer from '../../../js/components/PageContainer';

import {getGuide, getLessonToCourseMapping} from '../../../../server/services/cms';
import {getMaps} from '../../../../server/services/tags';
import {getGuideHeroData} from '../../../../server/services/guide';

export default function Page({
  guide, lessonMapping, guideHeroData,
}) {
  return (
    <GuidePage
      guide={guide}
      company={guideHeroData?.company}
      lessonMapping={lessonMapping}
    />
  );
}

Page.getLayout = (page, {guideHeroData}) => (
  <PageContainer>
    <GuideLayout data={guideHeroData}>
      {page}
    </GuideLayout>
  </PageContainer>
);

export async function getStaticProps({params}) {
  // lessonMapping: Helps construct lesson URLs using a mapping from lesson slug to course slug
  const [guide, lessonMapping, {roleMapId}, guideHeroData] = await Promise.all([
    getGuide(params.slugOrCompany),
    getLessonToCourseMapping(),
    getMaps(),
    getGuideHeroData(params.slugOrCompany),
  ]);

  if (!guide) return {notFound: true};

  guide.roleName = guide.roleName || roleMapId[guide.roleTag]?.name || '';

  // To make the guide serializable as JSON in the presence of undefined values
  Object.keys(guide).forEach((key) => {
    if (guide[key] === undefined) guide[key] = null;
  });

  return {
    props: {
      guide: JSON.parse(JSON.stringify(guide)),
      lessonMapping,
      guideHeroData: JSON.parse(JSON.stringify(guideHeroData)),
    },
    revalidate: 3600,
  };
}

// See https://nextjs.org/docs/api-reference/data-fetching/get-static-paths
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  };
}
